export default __webpack_public_path__ + "1540e72c575cb285857683a881be0e23.png";